import React, { useState } from 'react';
import MonthlyArtworkModal from './MonthlyArtworkModal';

const MonthlyArtworkSelector = ({
  monthlyArtwork = [],
  onMonthlyArtworkChange,
  disabled = false,
  isOngoing = false,
  hasPublication = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Get selected months count for display
  const selectedCount = monthlyArtwork.filter(item => item.isSelected).length;

  if (monthlyArtwork.length === 0) {
    // Show different message based on whether a publication is selected
    if (hasPublication) {
      return <div className="py-2 text-xs text-center text-amber-600">No issues available</div>;
    }
    return <div className="py-2 text-xs text-center text-gray-400">Select publication first</div>;
  }

  return (
    <>
      {/* Summary button */}
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        disabled={disabled}
        className={`w-full text-xs px-2 py-1 border rounded text-left ${
          disabled
            ? 'text-gray-400 bg-gray-100 cursor-not-allowed'
            : 'bg-white border-gray-300 hover:bg-gray-50'
        }`}
        style={{ fontSize: '14px' }}
      >
        {isOngoing ? 'Ongoing' : selectedCount > 0 ? `${selectedCount} issues` : 'Select months'}
      </button>

      {/* Modal */}
      <MonthlyArtworkModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        monthlyArtwork={monthlyArtwork}
        onMonthlyArtworkChange={onMonthlyArtworkChange}
        isOngoing={isOngoing}
      />
    </>
  );
};

export default MonthlyArtworkSelector;
